import { colors } from '../constants';
const styleOverrides = {
  root: {
    '&:hover,&:focus': {
      fontWeight: 'bold'
    }
  },
  underlineAlways: {
    textDecorationColor: 'currentcolor'
  }
};
const defaultProps = {
  underline: 'always',
  variant: 'body1',
  color: 'textPrimary'
};
const variants = [{
  props: {
    color: 'textPrimary'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.text.primary
    }
  }
}, {
  props: {
    color: 'primary'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.primary.dark
    }
  }
}, {
  props: {
    color: 'secondary'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.secondary.dark
    }
  }
}, {
  props: {
    color: 'info'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.info.dark
    }
  }
}, {
  props: {
    color: 'error'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.error.dark
    }
  }
}, {
  props: {
    color: 'textSecondary'
  },
  style: {
    '&:hover,&:focus': {
      color: colors.oriGrey.A900
    }
  }
}, {
  props: {
    variant: 'button'
  },
  style: {
    textUnderlineOffset: '.25em',
    textDecorationThickness: '2px'
  }
}];
export default {
  styleOverrides,
  defaultProps,
  variants
};